export default __webpack_public_path__ + "static/media/day5.ba6644c6.png";